import { render, staticRenderFns } from "./Yoyolumi.vue?vue&type=template&id=61f30e9f&scoped=true"
import script from "./Yoyolumi.vue?vue&type=script&lang=js"
export * from "./Yoyolumi.vue?vue&type=script&lang=js"
import style0 from "./Yoyolumi.vue?vue&type=style&index=0&id=61f30e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f30e9f",
  null
  
)

export default component.exports